<ion-content>
  <ion-list>
    <ion-item *ngFor="let view of cardView" [class.hidden]="!view.active" (click)="toggle(view)">
      <!-- <ion-checkbox slot="start" [(ngModel)]="tag.active"></ion-checkbox> -->
      <ion-icon slot="start" name="fa-eye" *ngIf="view.active"></ion-icon>
      <ion-icon slot="start" name="fa-eye-slash" *ngIf="!view.active"></ion-icon>
      <ion-label>{{view.name}}</ion-label>
    </ion-item>
  </ion-list>
</ion-content>
